import { RootState } from "shared/types";

export * from "./av";
export * from "./breakout";
export * from "./capability";
export * from "./caption";
export * from "./chat";
export * from "./in_person";
export * from "./info";
export * from "./poll";
export * from "./recording";
export * from "./resource";
export * from "./stage";
export * from "./timeline";
export * from "./user";

export const selectTimer = () => (state: RootState) => state.classroom.client.timer;

export const selectCurrentFilter = () => (state: RootState) =>
  state.classroom.client.current_filter;
